export const reportingRoutes = [
    {
        path: 'reports/shift',
        name: 'shift-report',
        component: () => import('../../views/ShiftReport.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'reports.view',
            title: 'Shift Report',
            breadcrumb: [
                { name: 'Reports', to: { name: 'reports' } },
                { name: 'Shift Report' }
            ]
        }
    },
    {
        path: 'reports/discrepancies',
        name: 'discrepancy-dashboard',
        component: () => import('../../views/DiscrepancyDashboard.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'reports.discrepancies.view'
        }
    }
];
